import { create } from 'zustand';

interface ChatState {
    desktopTitle?: string;
    mobileTitle?: string;
    isChatNudgingEnabled: boolean;
    isOnline: boolean;
    setHeroCtaData: (data: Partial<Pick<ChatState, 'isChatNudgingEnabled' | 'isOnline'>>) => void;
}

export const useChatStore = create<ChatState>((set) => ({
    isChatNudgingEnabled: false,
    isOnline: false,
    setHeroCtaData: (data) => set((state) => ({ ...state, ...data }))
}));
